import { Flex, Spinner } from '@chakra-ui/react';

export const Loader = () => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      position="absolute"
      width="full"
      height="full"
      bg="rgba(246, 247, 247, 0.9)"
      top="0"
      left="0"
      zIndex={2}
      borderBottomStartRadius="16px"
      borderBottomEndRadius="16px"
    >
      <Spinner top="50%" color="light.highlight" />
    </Flex>
  );
};
